export const dealTree = (res) => {
    for (let j = 0; j < res.length; j++) {
        const child = res[j].children;
        for (let i = 0; i < child.length; i++) {
            if (child[i].children.length < 1) {
                // 判断children的数组长度
                child[i].children = undefined;
            }
            else {
                dealTree(child);
            }
        }
    }
    return res;
};
